import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AiChatWindowService } from '../../services/ai-chat-window.service';

@Component({
  selector: 'qt-ai-chat-launcher',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <button
      mat-fab
      class="qt-ai-fab"
      [attr.aria-label]="ariaLabel()"
      (click)="open()">
      @if (useSvg()) {
        <mat-icon svgIcon="ai_star"></mat-icon>
      } @else {
        <mat-icon>auto_awesome</mat-icon>
      }
    </button>
  `,
  styleUrls: ['./ai-chat-launcher.component.scss'],
})
export class AiChatLauncherComponent {
  // Signal-based inputs
  readonly ariaLabel = input('AI Chat bot button');
  readonly useSvg = input(false);

  // Signal-based injection
  private readonly windows = inject(AiChatWindowService);

  open() {
    this.windows.openChat({ title: 'AI Chat' });
  }
}
